import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import { ErrorCodes } from "../../../Exception/ErrorCodes";
import { ErrorStatuses } from "../../../Exception/ErrorStatuses";
import { ErrorMessages } from "../../../Global/Messages/Messages";
import BaseValidator from "../../../Global/Validator/BaseValidator";
import MatchSummaryModel from "../Models/Summary/MatchSummaryModel";

export default class PredictorHelpersValidator extends BaseValidator {
  constructor(config: SDKConfigurationModel) {
    super(config.errorHandlingMode);
  }

  public validateMatchSummary = (matchSummary: MatchSummaryModel) => {
    if (!matchSummary) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_MATCH_SUMMARY,
        ErrorMessages.MATCH_SUMMARY_REQUIRED
      );
    }

    if (!matchSummary.predictions) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_MATCH_SUMMARY_PREDICTIONS,
        ErrorMessages.MATCH_SUMMARY_PREDICTIONS_REQUIRED
      );
    }

    if (
      !matchSummary.predictions.correctScore ||
      !matchSummary.predictions.correctScoreAdvanced
    ) {
      this.throwException(
        ErrorCodes.BAD_METHOD_CALL,
        ErrorStatuses.INVALID_MATCH_SUMMARY_PREDICTIONS_KEYS,
        ErrorMessages.INVALID_MATCH_SUMMARY_PREDICTIONS_KEYS + "correctScore and correctScoreAdvanced"
      );
    }
  };
}
